'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Wrapper = exports.SCROLL_ID = undefined;

var _assoc2 = require('ramda/src/assoc');

var _assoc3 = _interopRequireDefault(_assoc2);

var _path2 = require('ramda/src/path');

var _path3 = _interopRequireDefault(_path2);

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _templateObject = _taggedTemplateLiteral(['\n    position: relative;\n    height: calc(100vh);\n    overflow: hidden;\n    background-color: #2c3d4f;\n    font-size: 13px;\n    a {\n        color: #1890ff;\n        text-decoration: none;\n        outline: none;\n        &:hover {\n            color: #007eff;\n        }\n        &:actived {\n            color: #096dd9;\n        }\n    }\n'], ['\n    position: relative;\n    height: calc(100vh);\n    overflow: hidden;\n    background-color: #2c3d4f;\n    font-size: 13px;\n    a {\n        color: #1890ff;\n        text-decoration: none;\n        outline: none;\n        &:hover {\n            color: #007eff;\n        }\n        &:actived {\n            color: #096dd9;\n        }\n    }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n    background-color: #2c3d4f !important;\n    left: 0px;\n    position: absolute;\n    z-index: 999;\n    width: calc(100% - 0px) !important;\n    text-align: right;\n    padding-bottom: 0.5rem!important;\n    padding-top: 0.5rem!important;\n'], ['\n    background-color: #2c3d4f !important;\n    left: 0px;\n    position: absolute;\n    z-index: 999;\n    width: calc(100% - 0px) !important;\n    text-align: right;\n    padding-bottom: 0.5rem!important;\n    padding-top: 0.5rem!important;\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n    cursor: pointer;\n    margin: 0 5px;\n    color: #e94f34 !important;\n\n    background: transparent;\n    border: #e94f34 1px solid;\n    border-radius: 50%;\n    display: inline-block;\n    height: 28px;\n    width: 28px;\n    line-height: 28px;\n    text-align: center;\n    font-size: 14px;\n    transition: all .3s ease-in-out;\n\n    svg {\n        vertical-align: -0.0667em;\n    }\n'], ['\n    cursor: pointer;\n    margin: 0 5px;\n    color: #e94f34 !important;\n\n    background: transparent;\n    border: #e94f34 1px solid;\n    border-radius: 50%;\n    display: inline-block;\n    height: 28px;\n    width: 28px;\n    line-height: 28px;\n    text-align: center;\n    font-size: 14px;\n    transition: all .3s ease-in-out;\n\n    svg {\n        vertical-align: -0.0667em;\n    }\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n    cursor: default;\n    margin: 0 5px;\n    margin-right: 28px;\n    color: #a4b8d0 !important;\n\n    display: inline-block;\n    line-height: 28px;\n    font-size: 14px;\n'], ['\n    cursor: default;\n    margin: 0 5px;\n    margin-right: 28px;\n    color: #a4b8d0 !important;\n\n    display: inline-block;\n    line-height: 28px;\n    font-size: 14px;\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n    margin-top: 0px;\n    padding: 0px 20px;\n    margin-top: 46px;\n    margin-left: ', ';\n    background-color: #fff;\n    height: calc(100vh - 46px);\n    overflow: auto;\n    overflow-x: hidden;\n\n    transition: all .3s ease-in-out;\n'], ['\n    margin-top: 0px;\n    padding: 0px 20px;\n    margin-top: 46px;\n    margin-left: ', ';\n    background-color: #fff;\n    height: calc(100vh - 46px);\n    overflow: auto;\n    overflow-x: hidden;\n\n    transition: all .3s ease-in-out;\n']),
    _templateObject6 = _taggedTemplateLiteral(['\n    position: absolute;\n    top: -35px;\n    right: 18px;\n    cursor: pointer;\n    margin: 0 5px;\n    color: #DFE4ED !important;\n\n    background: transparent;\n    border: #DFE4ED 1px solid;\n    border-radius: 50%;\n    display: inline-block;\n    height: 28px;\n    width: 28px;\n    line-height: 28px;\n    text-align: center;\n    font-size: 14px;\n    transition: all .3s ease-in-out;\n\n    &:hover {\n        color: #e94f34 !important;\n        border: #e94f34 1px solid;\n    }\n\n    svg {\n        vertical-align: -0.0667em;\n    }\n'], ['\n    position: absolute;\n    top: -35px;\n    right: 18px;\n    cursor: pointer;\n    margin: 0 5px;\n    color: #DFE4ED !important;\n\n    background: transparent;\n    border: #DFE4ED 1px solid;\n    border-radius: 50%;\n    display: inline-block;\n    height: 28px;\n    width: 28px;\n    line-height: 28px;\n    text-align: center;\n    font-size: 14px;\n    transition: all .3s ease-in-out;\n\n    &:hover {\n        color: #e94f34 !important;\n        border: #e94f34 1px solid;\n    }\n\n    svg {\n        vertical-align: -0.0667em;\n    }\n']),
    _templateObject7 = _taggedTemplateLiteral(['\n    height: 100%;\n    position: absolute;\n    z-index: 1;\n    top: 0;\n    left: 0;\n    overflow-x: visible;\n    width: ', ';\n    z-index: 2001;\n    margin-top: 45px;\n    transition: all .3s ease-in-out;\n\n    & > div {\n        position: relative;\n    }\n\n    .menu-list-item {\n        text-align: ', ';\n    }\n'], ['\n    height: 100%;\n    position: absolute;\n    z-index: 1;\n    top: 0;\n    left: 0;\n    overflow-x: visible;\n    width: ', ';\n    z-index: 2001;\n    margin-top: 45px;\n    transition: all .3s ease-in-out;\n\n    & > div {\n        position: relative;\n    }\n\n    .menu-list-item {\n        text-align: ', ';\n    }\n']),
    _templateObject8 = _taggedTemplateLiteral(['\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n    flex-wrap: wrap;\n    padding-left: 0;\n    margin-top: 0;\n    margin-bottom: 0;\n    list-style: none;\n'], ['\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n    flex-wrap: wrap;\n    padding-left: 0;\n    margin-top: 0;\n    margin-bottom: 0;\n    list-style: none;\n']),
    _templateObject9 = _taggedTemplateLiteral(['\n    margin-left: 0;\n    overflow: hidden;\n    width: 100%;\n    cursor: pointer;\n\n    a {\n        border-left: 2px solid #2c3d4f;\n        color: #fff;\n        font-size: 14px;\n        font-weight: 500;\n        padding: 10px 16px 10px 14px;\n        display: block;\n        text-decoration: none;\n\n        &:hover {\n            border-radius: 0;\n            background-color: transparent;\n            color: #e94f34;\n            border-left: 2px solid #e94f34;\n            font-weight: 500;\n        }\n        &:focus {\n            background-color: #243444;\n            color: white;\n        }\n\n        &.actived {\n            background-color: transparent;\n            color: #e94f34;\n            border-left: 2px solid #e94f34;\n            -webkit-box-shadow: none;\n            box-shadow: none;\n            font-weight: 500;\n            background: #243444 !important;\n\n            &hover {\n                background-color: transparent;\n                color: #ffffff;\n                font-weight: 500;\n            }\n            &:focus {\n                background-color: transparent;\n                color: #ffffff;\n                font-weight: 500;\n            }\n        }\n    }\n'], ['\n    margin-left: 0;\n    overflow: hidden;\n    width: 100%;\n    cursor: pointer;\n\n    a {\n        border-left: 2px solid #2c3d4f;\n        color: #fff;\n        font-size: 14px;\n        font-weight: 500;\n        padding: 10px 16px 10px 14px;\n        display: block;\n        text-decoration: none;\n\n        &:hover {\n            border-radius: 0;\n            background-color: transparent;\n            color: #e94f34;\n            border-left: 2px solid #e94f34;\n            font-weight: 500;\n        }\n        &:focus {\n            background-color: #243444;\n            color: white;\n        }\n\n        &.actived {\n            background-color: transparent;\n            color: #e94f34;\n            border-left: 2px solid #e94f34;\n            -webkit-box-shadow: none;\n            box-shadow: none;\n            font-weight: 500;\n            background: #243444 !important;\n\n            &hover {\n                background-color: transparent;\n                color: #ffffff;\n                font-weight: 500;\n            }\n            &:focus {\n                background-color: transparent;\n                color: #ffffff;\n                font-weight: 500;\n            }\n        }\n    }\n']),
    _templateObject10 = _taggedTemplateLiteral(['\n    background: transparent !important;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n    flex-wrap: wrap;\n    padding-left: 0;\n    margin-bottom: 0;\n    list-style: none;\n'], ['\n    background: transparent !important;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-wrap: wrap;\n    flex-wrap: wrap;\n    padding-left: 0;\n    margin-bottom: 0;\n    list-style: none;\n']),
    _templateObject11 = _taggedTemplateLiteral(['\n    margin-left: 0;\n    padding-left: 0;\n    overflow: hidden;\n    width: 100%;\n    border-bottom: none !important;\n    cursor: pointer;\n\n    a {\n        color: #a4b8d0;\n        font-size: 12px;\n        font-weight: 400;\n        line-height: 1.3;\n        padding: 8px 10px 8px 30px;\n        display: block;\n        text-align: left;\n        -webkit-border-radius: 0;\n        border-radius: 0;\n        text-decoration: none;\n\n        &:hover {\n            border-radius: 0;\n            background-color: transparent;\n            color: #e94f34;\n            border-left: 2px solid #e94f34;\n            font-weight: 400;\n        }\n        &:focus {\n            background-color: #243444;\n            color: white;\n        }\n\n        &.actived {\n            background-color: transparent;\n            color: #e94f34;\n            border-left: 2px solid #e94f34;\n            -webkit-box-shadow: none;\n            box-shadow: none;\n            font-weight: 400;\n\n            &:focus {\n                background-color: transparent;\n                color: #ffffff;\n                font-weight: 400;\n            }\n        }\n    }\n'], ['\n    margin-left: 0;\n    padding-left: 0;\n    overflow: hidden;\n    width: 100%;\n    border-bottom: none !important;\n    cursor: pointer;\n\n    a {\n        color: #a4b8d0;\n        font-size: 12px;\n        font-weight: 400;\n        line-height: 1.3;\n        padding: 8px 10px 8px 30px;\n        display: block;\n        text-align: left;\n        -webkit-border-radius: 0;\n        border-radius: 0;\n        text-decoration: none;\n\n        &:hover {\n            border-radius: 0;\n            background-color: transparent;\n            color: #e94f34;\n            border-left: 2px solid #e94f34;\n            font-weight: 400;\n        }\n        &:focus {\n            background-color: #243444;\n            color: white;\n        }\n\n        &.actived {\n            background-color: transparent;\n            color: #e94f34;\n            border-left: 2px solid #e94f34;\n            -webkit-box-shadow: none;\n            box-shadow: none;\n            font-weight: 400;\n\n            &:focus {\n                background-color: transparent;\n                color: #ffffff;\n                font-weight: 400;\n            }\n        }\n    }\n']),
    _templateObject12 = _taggedTemplateLiteral(['\n    background: none repeat scroll 0 0 white;\n    border-top: 1px solid #e7eaec;\n    bottom: 0;\n    left: 0;\n    padding: 10px 20px;\n\n    .workload {\n        float: left;\n    }\n'], ['\n    background: none repeat scroll 0 0 white;\n    border-top: 1px solid #e7eaec;\n    bottom: 0;\n    left: 0;\n    padding: 10px 20px;\n\n    .workload {\n        float: left;\n    }\n']),
    _templateObject13 = _taggedTemplateLiteral(['\n    float: right;\n'], ['\n    float: right;\n']),
    _templateObject14 = _taggedTemplateLiteral(['\n    right: ', ';\n    opacity: ', ';\n    cursor: pointer;\n    position: fixed;\n    bottom: 30px;\n    width: 45px;\n    height: 45px;\n    z-index: 1000;\n    border-radius: 50%;\n    border: 0;\n    color: #fff;\n    background-color: #2c3d4f;\n    overflow: hidden;\n    transition: all .3s ease-in-out;\n    -webkit-font-smoothing: antialiased;\n\n    svg {\n        -webkit-font-smoothing: antialiased;\n    }\n'], ['\n    right: ', ';\n    opacity: ', ';\n    cursor: pointer;\n    position: fixed;\n    bottom: 30px;\n    width: 45px;\n    height: 45px;\n    z-index: 1000;\n    border-radius: 50%;\n    border: 0;\n    color: #fff;\n    background-color: #2c3d4f;\n    overflow: hidden;\n    transition: all .3s ease-in-out;\n    -webkit-font-smoothing: antialiased;\n\n    svg {\n        -webkit-font-smoothing: antialiased;\n    }\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactFinalForm = require('react-final-form');

var _fa = require('react-icons/fa');

var _reactScroll = require('react-scroll');

var _experiumPlayerHelpers = require('experium-player-helpers');

var _Wrapper = require('../context/Wrapper');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Styled = _styledComponents2.default.div(_templateObject);

var Header = _styledComponents2.default.div(_templateObject2);

var HeaderBtn = _styledComponents2.default.div(_templateObject3);

var HeaderLength = _styledComponents2.default.div(_templateObject4);

var Container = _styledComponents2.default.div(_templateObject5, function (_ref) {
    var isHide = _ref.isHide;
    return isHide ? '70px' : '220px';
});

var HeaderMenuBtn = _styledComponents2.default.div(_templateObject6);

var Menu = _styledComponents2.default.div(_templateObject7, function (_ref2) {
    var isHide = _ref2.isHide;
    return isHide ? '70px' : '220px';
}, function (_ref3) {
    var isHide = _ref3.isHide;
    return isHide ? 'center' : 'left';
});

var MenuList = _styledComponents2.default.ul(_templateObject8);

var MenuListItem = _styledComponents2.default.li(_templateObject9);

var MenuSubList = _styledComponents2.default.ul(_templateObject10);

var MenuSubListItem = _styledComponents2.default.ul(_templateObject11);

var Footer = _styledComponents2.default.div(_templateObject12);

var Version = _styledComponents2.default.div(_templateObject13);

var ScrollToTopButton = _styledComponents2.default.button(_templateObject14, function (_ref4) {
    var showToTop = _ref4.showToTop;
    return showToTop ? '30px' : '10px';
}, function (_ref5) {
    var showToTop = _ref5.showToTop;
    return showToTop ? '1' : '0';
});

var HEADER_TYPE = 'h2';
var TABLE_HEADER_TYPE = 'h4';
var SCROLL_ID = exports.SCROLL_ID = 'player-scroll-container';

var Wrapper = exports.Wrapper = function Wrapper(_ref6) {
    var _ref6$pages = _ref6.pages,
        pages = _ref6$pages === undefined ? [] : _ref6$pages,
        language = _ref6.language,
        style = _ref6.style,
        children = _ref6.children,
        viewMode = _ref6.viewMode,
        workloadForm = _ref6.workloadForm,
        workloadDocument = _ref6.workloadDocument,
        workloadLength = _ref6.workloadLength,
        workloadCurrentLength = _ref6.workloadCurrentLength,
        minLength = _ref6.minLength,
        getLength = _ref6.getLength;

    var container = (0, _react.useRef)(null);

    var _useState = (0, _react.useState)({
        showSpecification: true
    }),
        _useState2 = _slicedToArray(_useState, 2),
        options = _useState2[0],
        setOptions = _useState2[1];

    var _useState3 = (0, _react.useState)(true),
        _useState4 = _slicedToArray(_useState3, 2),
        menuHide = _useState4[0],
        setMenuHide = _useState4[1];

    var _useState5 = (0, _react.useState)(null),
        _useState6 = _slicedToArray(_useState5, 2),
        current = _useState6[0],
        setCurrent = _useState6[1];

    var _useState7 = (0, _react.useState)(false),
        _useState8 = _slicedToArray(_useState7, 2),
        showToTop = _useState8[0],
        setShowTop = _useState8[1];

    var links = [];
    var pagesLinks = {};

    pages.forEach(function (page, pageIndex) {
        var items = page.items || [];

        items.map(function (item, itemIndex) {
            if (item.type === HEADER_TYPE) {
                links.push({
                    type: HEADER_TYPE,
                    name: 'field-' + pageIndex + '-' + itemIndex,
                    pageIndex: pageIndex,
                    itemIndex: itemIndex,
                    text: (0, _experiumPlayerHelpers.getText)(item, language) || '-'
                });

                pagesLinks[pageIndex] = true;
            }

            if (item.type === 'table' && item.layout !== 'horz') {
                links.push({
                    type: 'table',
                    table: true,
                    name: 'table-' + pageIndex + '-' + itemIndex,
                    pageIndex: pageIndex,
                    itemIndex: itemIndex,
                    text: (0, _experiumPlayerHelpers.getText)((item.items || []).find(function (item) {
                        return item.type === TABLE_HEADER_TYPE;
                    }) || (0, _path3.default)(['items', 0], item) || (0, _path3.default)(['items', 0, 'items', 0], item), language) || '-'
                });
            }
        });

        if (menuHide && !pagesLinks[pageIndex]) {
            links.push({
                type: HEADER_TYPE,
                name: 'page-' + pageIndex,
                pageIndex: pageIndex,
                text: ''
            });
        }
    });

    var onScroll = function onScroll(e) {
        if (!e.target || e.target.id !== SCROLL_ID) {
            return;
        }

        var bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;

        if (bottom && links.length) {
            return setTimeout(function () {
                setCurrent(links[links.length - 1].name);
                setShowTop(true);
            }, 300);
        }

        if (!e.target.scrollTop) {
            if (links[0]) {
                setCurrent(links[0].name);
            }
            setShowTop(false);
        } else {
            setShowTop(true);
        }
    };

    var onInactiveCheck = function onInactiveCheck(from, element) {
        if (container.current) {
            var index = links.findIndex(function (item) {
                return item.name === from;
            });
            var bottom = container.scrollHeight - container.scrollTop === container.clientHeight;

            if (!bottom && element.offsetTop > container.current.scrollTop) {
                setCurrent(links[Math.max(0, index - 1)].name);
            }
        }
    };

    var onActiveSet = function onActiveSet(to) {
        var bottom = container.scrollHeight - container.scrollTop === container.clientHeight;

        if (!bottom) {
            setCurrent(to);
        }
    };

    var scrollToTop = function scrollToTop() {
        _reactScroll.animateScroll.scrollToTop({
            duration: 300,
            smooth: 'ease',
            containerId: SCROLL_ID
        });
    };

    var toggleShowOption = function toggleShowOption() {
        return setOptions((0, _assoc3.default)('showSpecification', !options.showSpecification, options));
    };

    return _react2.default.createElement(
        Styled,
        { styleString: style },
        _react2.default.createElement(
            Header,
            null,
            _react2.default.createElement(
                _reactFinalForm.FormSpy,
                { subscriptions: { values: true } },
                function (_ref7) {
                    var values = _ref7.values;

                    if (getLength) {
                        var currentLength = getLength ? getLength(values) : 0;

                        return _react2.default.createElement(
                            _react.Fragment,
                            null,
                            _react2.default.createElement(
                                HeaderLength,
                                null,
                                _react2.default.createElement(_experiumPlayerHelpers.FormattedMessage, {
                                    id: 'lengthText',
                                    values: {
                                        length: currentLength,
                                        minLength: minLength
                                    }
                                })
                            )
                        );
                    }

                    return null;
                }
            ),
            _react2.default.createElement(
                HeaderBtn,
                { onClick: toggleShowOption },
                options.showSpecification ? _react2.default.createElement(_fa.FaCommentSlash, null) : _react2.default.createElement(_fa.FaComment, null)
            )
        ),
        _react2.default.createElement(
            Menu,
            { isHide: menuHide },
            _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    HeaderMenuBtn,
                    { onClick: function onClick() {
                            setMenuHide(!menuHide);
                        } },
                    menuHide ? _react2.default.createElement(_fa.FaArrowRight, null) : _react2.default.createElement(_fa.FaArrowLeft, null)
                ),
                _react2.default.createElement(
                    MenuList,
                    null,
                    links.map(function (item, index) {
                        return _react2.default.createElement(
                            MenuListItem,
                            { key: index, className: 'menu-list-item' },
                            menuHide ? item.type === HEADER_TYPE ? _react2.default.createElement(
                                _reactScroll.Link,
                                {
                                    to: item.name,
                                    containerId: SCROLL_ID,
                                    smooth: true,
                                    spy: true,
                                    isDynamic: true,
                                    duration: 300,
                                    className: item.name === current || !current && index === 0 ? 'actived' : '',
                                    onSetActive: onActiveSet,
                                    onSetInactive: onInactiveCheck,
                                    onClick: function onClick() {
                                        return setCurrent(item.name);
                                    }
                                },
                                _react2.default.createElement('span', { title: item.text, dangerouslySetInnerHTML: {
                                        __html: menuHide ? item.pageIndex + 1 + '.' : item.text
                                    } })
                            ) : null : item.type === HEADER_TYPE ? _react2.default.createElement(
                                _reactScroll.Link,
                                {
                                    to: item.name,
                                    containerId: SCROLL_ID,
                                    smooth: true,
                                    spy: true,
                                    isDynamic: true,
                                    duration: 300,
                                    className: item.name === current || !current && index === 0 ? 'actived' : '',
                                    onSetActive: onActiveSet,
                                    onSetInactive: onInactiveCheck,
                                    onClick: function onClick() {
                                        return setCurrent(item.name);
                                    }
                                },
                                _react2.default.createElement('span', { dangerouslySetInnerHTML: {
                                        __html: item.text
                                    } })
                            ) : _react2.default.createElement(
                                MenuSubList,
                                null,
                                _react2.default.createElement(
                                    MenuSubListItem,
                                    { className: 'menu-sublist-item' },
                                    _react2.default.createElement(
                                        _reactScroll.Link,
                                        {
                                            to: item.name,
                                            containerId: SCROLL_ID,
                                            smooth: true,
                                            spy: true,
                                            duration: 300,
                                            className: item.name === current ? 'actived' : '',
                                            onSetActive: onActiveSet,
                                            onSetInactive: onInactiveCheck,
                                            onClick: function onClick() {
                                                return setCurrent(item.name);
                                            }
                                        },
                                        _react2.default.createElement('span', { dangerouslySetInnerHTML: {
                                                __html: item.text
                                            } })
                                    )
                                )
                            )
                        );
                    })
                )
            )
        ),
        _react2.default.createElement(
            Container,
            { innerRef: container, id: SCROLL_ID, isHide: menuHide, onScroll: onScroll },
            _react2.default.createElement(
                _Wrapper.WrapperContext.Provider,
                { value: options },
                children
            ),
            _react2.default.createElement(
                ScrollToTopButton,
                { showToTop: showToTop, onClick: scrollToTop },
                _react2.default.createElement(_fa.FaLongArrowAltUp, { size: 18 })
            ),
            _react2.default.createElement(
                Footer,
                null,
                _react2.default.createElement(
                    'div',
                    { className: 'workload' },
                    viewMode ? _react2.default.createElement(_experiumPlayerHelpers.FormattedMessage, {
                        id: workloadDocument && workloadLength > 0 ? workloadForm ? 'workloadCurrentLengthText' : 'workloadMinText' : workloadDocument ? 'workloadText' : 'noWorkloadText',
                        values: {
                            length: workloadCurrentLength || 0,
                            minLength: workloadLength || 0
                        }
                    }) : null
                ),
                '3.1.98' ? _react2.default.createElement(
                    Version,
                    null,
                    'v',
                    '3.1.98'
                ) : _react2.default.createElement(
                    Version,
                    null,
                    'dev'
                )
            )
        )
    );
};

Wrapper.propTypes = {
    pages: _propTypes2.default.array,
    language: _propTypes2.default.string,
    getLength: _propTypes2.default.func,
    workloadCurrentLength: _propTypes2.default.number,
    workloadLength: _propTypes2.default.number,
    workloadDocument: _propTypes2.default.bool,
    workloadForm: _propTypes2.default.bool,
    viewMode: _propTypes2.default.bool,
    minLength: _propTypes2.default.number,
    style: _propTypes2.default.string,
    children: _propTypes2.default.node,
    hasButtons: _propTypes2.default.bool
};